module.exports = "<h1>LOADING!!@111</h1>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/controller/eod-sales-route-redirect.component.html
// module id = ../../../../../src/app/views/daily-recon/eod-recon/controller/eod-sales-route-redirect.component.html
// module chunks = main